import * as React from 'react';
import {Form, minLength, required, TextInput, useLogin, useNotify} from 'react-admin';
import {useFormContext} from "react-hook-form";
import {ErrorResponse} from "../../types/errors-response";
import {errorsExtractor} from "../../utils/errors-extractor";

type LoginValues = { email: string; password: string };

const SubmitButton = () => {
  const notify = useNotify();
  const login = useLogin();
  const {setError,getValues, formState: {isValid, isLoading, isSubmitted}} = useFormContext<LoginValues>();

  const onSubmit = async () => {
    const { email, password } = getValues();

    try {
      await login({ username: email, password });
    } catch (e: any) {
      const body: ErrorResponse | undefined = e?.body;
      if (!body) {
        notify('Something went wrong');
        return
      }
      if (body && 'details' in body) {
        errorsExtractor(body as ErrorResponse, setError)
        return;
      }
      notify(body.message || ('message' in e ? e.message as string : JSON.stringify(e)), {type: 'warning'});
    }
  };

  return (
    <div style={{ marginTop: 16 }}>
      <button type="button" disabled={(!isValid && isSubmitted) || isLoading} onClick={onSubmit} style={{ width: '100%', padding: 10 }}>
        Sign in
      </button>
    </div>
  )
}

export default function LoginPage() {

  return (
    <div style={{ maxWidth: 420, margin: '10vh auto' }}>
      <h2 style={{ marginBottom: 16 }}>Admin Login</h2>
      <Form defaultValues={{ email: '', password: '' }} noValidate>
        <TextInput source="email" type="email" label="Email" fullWidth validate={[required()]} />
        <TextInput
          source="password"
          type="password"
          label="Password"
          fullWidth
          validate={[required(), minLength(8)]}
        />
        <SubmitButton/>
        <div style={{ marginTop: 12, textAlign: 'center' }}>
          <a href="/public#/forgot-password">Forgot password?</a>
        </div>
      </Form>
    </div>
  );
}
